export default "/kiban/_next/static/images/spinner-a284e3310966c77afb0c8c0cdedf789b.gif";